<app-student-form (onSubmitCallback)="onSubmit($event[0])" [examReportId]="examReportId" [studentId]="studentId"></app-student-form>
